<div class="notes-sidebar">
    <div *ngIf="enableStudentThemes" class="notes-sidebar-scene" aria-hidden="true">
        <div class="notes-scene-rocket"></div>
    </div>

    <div class="header">
        <div class="icon-wrapper" (click)="close()" style="cursor: pointer;">
            <lucide-icon name="file-stack" [size]="20"></lucide-icon>
        </div>
    </div>

    <button class="add-note-btn" (click)="openEditor()">
        <lucide-icon name="clipboard-plus" [size]="16"></lucide-icon>
        <span>Add note</span>
    </button>

    <div class="notes-list">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="spinner"></div>
            <p>Loading notes...</p>
        </div>

        <!-- Empty State -->
        <div *ngIf="!isLoading && notes.length === 0" class="empty-state">
            <p>No notes yet. Click "Add note" to create your first note!</p>
        </div>

        <!-- Notes List -->
        <div class="note-item" *ngFor="let note of notes" (click)="openEditorWithNote(note, $event)">
            <div class="indicator-line" [style.background-color]="note.color"></div>
            <div class="note-content">
                <div class="note-header">
                    <span class="note-title">{{ note.title }}</span>
                    <div class="menu-wrapper" (click)="toggleMenu(note.id, $event)">
                        <button class="more-options">
                            <lucide-icon name="more-horizontal" [size]="16"></lucide-icon>
                        </button>
                        <div class="dropdown-tooltip" *ngIf="note.showMenu">
                            <div class="dropdown-item" (click)="editNote(note, $event)">
                                <svg class="dropdown-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.16699 2.29199L11.708 5.83299M1.16699 13H4.70799L12.667 5.04099C13.0222 4.68582 13.2213 4.20527 13.2213 3.70449C13.2213 3.20372 13.0222 2.72317 12.667 2.36799L11.632 1.33299C11.2768 0.977823 10.7963 0.778687 10.2955 0.778687C9.79472 0.778687 9.31417 0.977823 8.95899 1.33299L1.16699 9.12499V13Z" stroke="#471966" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                Edit
                            </div>
                            <div class="dropdown-item" (click)="openModal('rename', note, $event)">
                                <svg class="dropdown-icon" width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.00002 1.56098L6.43906 0L5.35742 1.08163L6.91838 2.6426L8.00002 1.56098Z" fill="#471966"/>
                                    <path d="M1.59961 6.40039L3.31669 6.24431L6.27149 3.28951L4.71049 1.72852L1.75571 4.68331L1.59961 6.40039Z" fill="#471966"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.2 8.0002H0V7.2002H5.2V8.0002Z" fill="#471966"/>
                                </svg>
                                Rename
                            </div>
                            <div class="dropdown-item" (click)="openModal('delete', note, $event)">
                                <svg class="dropdown-icon" width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.8045 3.14284H1.72791C1.24938 3.14284 0.859824 3.49543 0.859824 3.92856V10.2143C0.859824 10.6474 1.24938 11 1.72791 11H7.8045C8.28303 11 8.67259 10.6474 8.67259 10.2143V3.92856C8.67259 3.49543 8.28303 3.14284 7.8045 3.14284ZM3.51783 9.03282C3.49993 9.03478 3.48148 9.03576 3.46358 9.03576C3.24818 9.03576 3.06101 8.89041 3.03333 8.69152L2.59928 5.54866C2.56944 5.33357 2.73818 5.13714 2.97635 5.11013C3.21182 5.08164 3.43101 5.23584 3.46085 5.45142L3.8949 8.59428C3.92419 8.80937 3.75601 9.0058 3.51783 9.03282ZM6.49918 8.69153C6.47151 8.89041 6.28433 9.03577 6.06893 9.03577C6.05103 9.03577 6.03258 9.03479 6.01468 9.03283C5.77704 9.00582 5.6083 8.80939 5.63761 8.5943L6.07165 5.45143C6.10095 5.23586 6.31905 5.08165 6.55615 5.11014C6.79379 5.13715 6.96253 5.33357 6.93322 5.54867L6.49918 8.69153ZM8.67259 1.57143H6.93642V1.17857C6.93642 0.528881 6.35209 0 5.63429 0H3.89812C3.18032 0 2.59599 0.528881 2.59599 1.17857V1.57143H0.859824C0.62001 1.57143 0.425781 1.74723 0.425781 1.96429C0.425781 2.18135 0.62001 2.35715 0.859824 2.35715H8.67259C8.9124 2.35715 9.10663 2.18135 9.10663 1.96429C9.10663 1.74723 8.9124 1.57143 8.67259 1.57143ZM6.06833 1.57143H3.46408V1.17857C3.46408 0.962006 3.65885 0.785716 3.89812 0.785716H5.63429C5.87356 0.785716 6.06833 0.962006 6.06833 1.17857V1.57143Z" fill="#471966"/>
                                </svg>
                                Delete
                            </div>
                        </div>
                    </div>
                </div>
                <span class="note-time">{{ note.time }}</span>
            </div>
        </div>
    </div>
</div>

<!-- Note Editor Modal -->
<div class="modal-overlay" *ngIf="isEditorOpen">
    <div class="editor-card">
        <input type="text" class="editor-title" placeholder="Title" [(ngModel)]="currentNote.title" />

        <div class="editor-toolbar">
            <button class="toolbar-btn"><lucide-icon name="bold" [size]="16"></lucide-icon></button>
            <button class="toolbar-btn"><lucide-icon name="italic" [size]="16"></lucide-icon></button>
            <button class="toolbar-btn"><lucide-icon name="underline" [size]="16"></lucide-icon></button>
            <div class="divider"></div>
            <button class="toolbar-btn"><lucide-icon name="list" [size]="16"></lucide-icon></button>
            <button class="toolbar-btn"><lucide-icon name="list-ordered" [size]="16"></lucide-icon></button>
        </div>

        <textarea class="editor-content" placeholder="Start typing..." [(ngModel)]="currentNote.content"></textarea>

        <div class="editor-footer">
            <button class="cancel-btn" (click)="closeEditor()">Cancel</button>
            <button class="save-btn" (click)="saveNote()">Save</button>
        </div>
    </div>
</div>

<!-- Rename Modal -->
<div class="modal-backdrop" *ngIf="showRenameModal">
    <div class="modal-content">
        <h3 class="modal-header">Rename Note</h3>
        <input [(ngModel)]="renameInput" class="styled-input" placeholder="Enter new note title" />
        
        <div class="modal-actions">
            <button class="cancel-btn" (click)="closeModal()">Cancel</button>
            <button class="save-btn" (click)="confirmRename()">Save</button>
        </div>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal-backdrop" *ngIf="showDeleteModal">
    <div class="modal-content">
        <h3 class="modal-header">Delete Note</h3>
        <p class="modal-text">Are you sure you want to delete this note?</p>
        
        <div class="modal-actions">
            <button class="cancel-btn" (click)="closeModal()">Cancel</button>
            <button class="save-btn" (click)="confirmDelete()">Yes, Delete</button>
        </div>
    </div>
</div>
